import axios from "./axios"

export default {
  getAccountSettings: async (params) => {
    try {
      return await axios.get("/self/settings")
    } catch (error) {
      throw error
    }
  },

  setAccountSettings: async (data) => {
    try {
      return await axios.put("/self/settings", data)
    } catch (error) {
      throw error
    }
  },

  resendEmail: async () => {
    try {
      return await axios.get("/self/resend_email")
    } catch (error) {
      throw error
    }
  },

  clearToken: async () => {
    try {
      return await axios.get("/self/clear_token")
    } catch (error) {
      throw error
    }
  },

  confirmUpdateEmail: async (token) => {
    try {
      return await axios.put("/self/update_email", {
        change_email_token: token,
      })
    } catch (error) {
      throw error
    }
  },

  addAdmin: async (data) => {
    try {
      return await axios.post("/self/settings/admins", data)
    } catch (error) {
      throw error
    }
  },

  updateAdmin: async (adminId, data) => {
    try {
      return await axios.put(`/self/settings/admins/${adminId}`, data)
    } catch (error) {
      throw error
    }
  },

  confirmPasswordUpdate: async (token) => {
    try {
      return await axios.put("/self/confirm_password_update", {
        change_password_token: token,
      })
    } catch (error) {
      throw error
    }
  },

  acceptAdminInvitation: async (token) => {
    try {
      return await axios.get(`/accept-admin-invitation/${token}`)
    } catch (error) {
      throw error
    }
  },
}
